import {
  REQUEST_ALBUM,
  RECEIVE_ALBUM,
  INVALIDATE_ALBUM
} from '../actions/AlbumActions';

const PropsInitialState = {
  album: {
    title: {
      rendered: '...'
    },
    album_cover: {
      url: '',
    },
    album_genre: [],
    album_songs: [],
    date: ''
  }
};

// todo: understand why the API is not consistent
const processAlbum = data => {
  const albumCover = data.album_cover || data.album_cover;
  const ret = Object.assign({}, data, {
    album_songs: data.album_songs.map(song => {
      let album = song.product_album || {};

      // fix the api endpoint
      if (!album.id && !album.length) {
        album = Object.values(album)[0];
      }

      album.url = album.url || albumCover.url;
      song.product_album = album;


      return song;
    }),
    album_cover: albumCover,
  });

  return ret;
}

function posts(
  state = {
    isFetching: false,
    didInvalidate: false,
    items: []
  },
  action
) {
  switch (action.type) {
  case REQUEST_ALBUM: {
    return Object.assign({}, state, {
      isFetching: true,
      didInvalidate: false,
      ...PropsInitialState
    });
  }
  case RECEIVE_ALBUM: {
    return Object.assign({}, state, {
      isFetching: false,
      didInvalidate: false,
      album: processAlbum(action.album),
      lastUpdated: action.receivedAt
    });
  }
  case INVALIDATE_ALBUM: {
    return Object.assign({}, state, {
      isFetching: false,
      didInvalidate: false,
      album: {}
    });
  }
  default:
    return state;
  }
}

function AlbumReducer(state = PropsInitialState, action) {
  switch (action.type) {
  case REQUEST_ALBUM:
  case RECEIVE_ALBUM:
  case INVALIDATE_ALBUM: {
    return Object.assign({}, state, posts(state, action));
  }
  default: {
    return state;
  }
  }
}

export {
  AlbumReducer
};


// WEBPACK FOOTER //
// ./src/reducers/AlbumReducer.js